import { SSOLoginResponse } from '@/types/loginResponse'
import { AuthenticationResult } from '@/types/authenticationResult'

type NewPasswordHttp = (username: string, session: string, newPassword: string) => Promise<SSOLoginResponse>
type RedirectToRetrieveToken = (authenticationResult: AuthenticationResult) => Promise<void>
type ResetPasswordHashedKeyHttp = (hashedPassword: string, newPassword: string) => Promise<SSOLoginResponse>
const state: { username?: string, session?: string, redirectUrlAfterLogin?: string } = {
  username: undefined,
  session: undefined,
  redirectUrlAfterLogin: undefined
}

export const isResetPasswordInitialized = () => {
  return state.session && state.username && state.redirectUrlAfterLogin
}

export const initResetPassword = (username: string, session: string, redirectUrlAfterLogin: string) => {
  state.username = username
  state.session = session
  state.redirectUrlAfterLogin = redirectUrlAfterLogin
}

export const resetPasswordFlow = (newPasswordHttp: NewPasswordHttp, redirectToRetrieveToken: RedirectToRetrieveToken) => async (newPassword: string) => {
  if (!state.session || !state.username || !state.redirectUrlAfterLogin) {
    throw Error('Must set username and session before reset password')
  }

  const loginResponse = await newPasswordHttp(state.username, state.session, newPassword)
  redirectToRetrieveToken(loginResponse.AuthenticationResult)
}

export const resetPasswordHashFlow = (resetPasswordHashedKeyHttp: ResetPasswordHashedKeyHttp, redirectToRetrieveToken: RedirectToRetrieveToken) =>
  async (newPassword: string, hashedPassword: string) => {
    const loginResponse = await resetPasswordHashedKeyHttp(hashedPassword, newPassword)
    redirectToRetrieveToken(loginResponse.AuthenticationResult)
  }
